<template>
  <div>
    <div class="card text-center">
      <div class="p-5">
        <i class="fa fa-user fa-2x"></i>
        <p>{{ user.displayName }}</p>
      </div>
      <div>
        <ul class="list-group">
          <router-link
            tag="li"
            class="list-group-item"
            active-class="active"
            :to="'/user/profile'"
          >
            <a class="nav-link" style="color: #000">Profile</a>
          </router-link>
          <router-link
            tag="li"
            class="list-group-item"
            active-class="active"
            :to="'/user/orders'"
          >
            <a class="nav-link" style="color: #000">My Orders</a>
          </router-link>
          <router-link
            tag="li"
            class="list-group-item"
            active-class="active"
            :to="'/user/wallet'"
          >
            <a class="nav-link" style="color: #000">My Wallet</a>
          </router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import constants from "../modules/constants";
export default {
  data() {
    return {
      settings: {
        displayName: "",
        photoURL: "",
        initialImage: ""
      }
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser"
    })
  },
  mounted() {
    this.settings.displayName = this.user.displayName;
    this.settings.photoURL =
      this.user.photoURL || constants.profile.default_user_image;
    this.settings.initialImage =
      this.user.photoURL || constants.profile.default_user_image;
  }
};
</script>

<style scoped>
.list-group-item.active {
  background-color: #f69325 !important;
  border-color: #f69325;
}
</style>
